import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";

export default class SwivuStateColumn extends SwivuSortColumn {
  static get $name() {
    return "SwivuStateColumn"
  }

  static get fields() {
    return ["regionsToIgnore"];
  }

  static get type() {
    return WIDGET_KEYS.swivuStateColumn
  }

  getState() {
    const state = super.getState();
    if (this.regionsToIgnore) {
      state.autoHeight = this.autoHeight;
    }
    return state;
  }

  applyState(state) {
    super.applyState(state);
    // Auto height is disabled in subgrid region until below issue is resolved
    // https://github.com/bryntum/support/issues/9069
    if (this.regionsToIgnore) {
      const canApplyAutoHeight = !this.regionsToIgnore.includes(this.region);
      this.autoHeight = state.autoHeight ? canApplyAutoHeight && state.autoHeight:  false;
      // Auto Height is not properly adjusted when applying state, therefore adding a delay
      setTimeout(() => {
        /* The column is destroyed if the user switches pages faster then the timeout callback is invoked. To prevent this we are checking if the column exists */
        if (!this.isDestroyed) this.grid.refreshRows()
      })
    }
  }
}

ColumnStore.registerColumnType(SwivuStateColumn);
